import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BAppleSignIn',
  emits: ['login-success', 'login-failure'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var config = useRuntimeConfig();
    var notifier = useNotifier();
    var scriptUrl = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    var scriptLoaded = false;
    var listenersAttached = false;
    function handleSuccess(event) {
      emit('login-success', event === null || event === void 0 ? void 0 : event.detail);
    }
    function handleError(event) {
      if ((event === null || event === void 0 ? void 0 : event.detail.error) === 'user_trigger_new_signin_flow' || (event === null || event === void 0 ? void 0 : event.detail.error) === 'popup_closed_by_user') {
        return;
      }
      emit('login-failure', event === null || event === void 0 ? void 0 : event.detail.error);
    }
    function initializeAppleSignIn() {
      if (!listenersAttached) {
        try {
          window.AppleID.auth.init({
            clientId: config.appleSSOClientID,
            scope: 'email name',
            redirectURI: config.appleSSORedirectURI,
            state: new Date().toString(),
            usePopup: true // or false if you want a redirect
          });
        } catch (error) {
          notifier.showMessage({
            content: "'Error initializing Apple Sign In: ".concat(error, "'"),
            type: 'error'
          });
        }
        document.addEventListener('AppleIDSignInOnSuccess', handleSuccess);
        document.addEventListener('AppleIDSignInOnFailure', handleError);
        listenersAttached = true;
      }
    }
    function loadAppleScript() {
      if (window.AppleID && scriptLoaded) {
        // Script already loaded and initialized
        return;
      }
      var script = document.createElement('script');
      script.src = scriptUrl;
      script.onload = function () {
        initializeAppleSignIn();
        scriptLoaded = true;
      };
      document.head.appendChild(script);
    }
    function signInWithApple() {
      // This method will be triggered when the user clicks the sign-in button
      if (!window.AppleID) {
        notifier.showMessage({
          content: 'AppleID script not loaded yet.',
          type: 'error'
        });
        return;
      }
      window.AppleID.auth.signIn();
    }
    onMounted(function () {
      loadAppleScript();
    });
    onUnmounted(function () {
      // Remove event listeners if they were added
      if (listenersAttached) {
        document.removeEventListener('AppleIDSignInOnSuccess', handleSuccess);
        document.removeEventListener('AppleIDSignInOnFailure', handleError);
      }
    });
    return {
      __sfc: true,
      emit: emit,
      config: config,
      notifier: notifier,
      scriptUrl: scriptUrl,
      scriptLoaded: scriptLoaded,
      listenersAttached: listenersAttached,
      handleSuccess: handleSuccess,
      handleError: handleError,
      initializeAppleSignIn: initializeAppleSignIn,
      loadAppleScript: loadAppleScript,
      signInWithApple: signInWithApple
    };
  }
});